import { Directive, OnInit, OnDestroy, Optional, Host } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: 'ng-select[appClearSearchOnSelect]',
    standalone: false,
})
export class ClearSearchOnSelectDirective implements OnInit, OnDestroy {
    private unsubscribeAll = new Subject<void>();

    public constructor(
        @Host() @Optional() private readonly ngSelect: NgSelectComponent
    ) {}

    public ngOnInit(): void {
        if (!this.ngSelect) {
            return;
        }

        // For multi-select dropdowns, listen to addEvent which fires when an item is added
        if (this.ngSelect.multiple()) {
            outputToObservable(this.ngSelect.addEvent)
                .pipe(takeUntil(this.unsubscribeAll))
                .subscribe(() => {
                    const items = this.ngSelect.itemsList;
                    const markedIndex = items.markedIndex;

                    // Clear search term and reset filter to show all items
                    this.ngSelect.filter('');

                    // Keep the highlight where ng-select 5 left it: on the
                    // later of the previously marked option and the one just
                    // added, rather than jumping back to the first selection.
                    const index = Math.max(
                        markedIndex,
                        items.filteredItems.indexOf(items.lastSelectedItem)
                    );
                    if (index > -1) {
                        items.markItem(items.filteredItems[index]);
                    }
                });
        }
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }
}
